import { useMemo } from 'react';

function useOptions({
  options: optionsProp,
  searchValue: searchValueProp,
  selectedIds
}) {
  const searchValue = searchValueProp.toLowerCase();
  const filteredList = useMemo(() => {
    if (!searchValue) {
      return optionsProp;
    }
    const output = [];
    optionsProp.forEach((level1) => {
      if ("options" in level1) {
        if (level1.name.toLowerCase().includes(searchValue)) {
          output.push(level1);
        } else {
          const overlappingOptions = level1.options.filter(
            ({ name }) => name.toLowerCase().includes(searchValue)
          );
          if (overlappingOptions.length) {
            output.push({ ...level1, options: overlappingOptions });
          }
        }
      } else if (level1.name.toLowerCase().includes(searchValue)) {
        output.push(level1);
      }
    });
    return output;
  }, [optionsProp, searchValue]);
  const filteredOptions = useMemo(() => {
    const output = [];
    filteredList.forEach((level1) => {
      if ("options" in level1) {
        level1.options.forEach((level2) => {
          output.push(level2);
        });
      } else {
        output.push(level1);
      }
    });
    return output;
  }, [filteredList]);
  const allOptions = useMemo(() => {
    const output = [];
    optionsProp.forEach((level1) => {
      if ("options" in level1) {
        level1.options.forEach((level2) => {
          output.push(level2);
        });
      } else {
        output.push(level1);
      }
    });
    return output;
  }, [optionsProp]);
  const selectedOptions = allOptions.filter(
    ({ id }) => selectedIds.includes(id)
  );
  return {
    filteredList,
    filteredOptions,
    allOptions,
    selectedOptions
  };
}

export { useOptions };
//# sourceMappingURL=useOptions.js.map
